/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profileviews1Inputs */

const en_profileviews1 = /** @type {(inputs: Profileviews1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile views`)
};

const de_profileviews1 = /** @type {(inputs: Profileviews1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilaufrufe`)
};

/**
* | output |
* | --- |
* | "Profile views" |
*
* @param {Profileviews1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profileviews1 = /** @type {((inputs?: Profileviews1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profileviews1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profileviews1(inputs)
	return de_profileviews1(inputs)
});
export { profileviews1 as "profileViews" }